import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IValidateRequestBody, IValidateResponseBody } from './types';

export const validate = async (payload: IValidateRequestBody): Promise<IValidateResponseBody> => {
  const res = await fetch(`${API_URL}/validation/validation`, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json' },
  });

  if (!res.ok) {
    const json = await res.json().catch(() => null);
    throw new Error(json?.message ?? 'Something went wrong whilst triggering validation');
  }

  return await res.json();
};
